<template>
  <div>
    <div class="crop-stage-program__image" v-if="item.images.length">
      <responsive-image :images="item.images" />
    </div>

    <div class="crop-stage-program__text">
      <div class="crop-stage-program__title">
        {{ item.title }}
      </div>
      <div class="crop-stage-program__description" v-if="item.description">
        {{ item.description }}
      </div>
    </div>
  </div>
</template>

<script>
// components
import ResponsiveImage from '../elements/ResponsiveImage';

export default {
  name: 'crop-stage-program-thumb',
  components: {
    ResponsiveImage,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>
